import React from 'react'

import DigiHealthLandingWrapper from './DigiHealthLanding/DigiHealthLandingWrapper'
import TopViewIcon from './TopViewIcon/TopViewIcon'

const DigiHealthWrapper = () => {
  return (
    <>
      <TopViewIcon/>
      
      <DigiHealthLandingWrapper/>
    </>
  )
}

export default DigiHealthWrapper
